<template>
  <div class="sidebar">
    <b-nav vertical v-if="currentUser">
      <b-nav-item style="margin: auto; margin-top: 50px;" exact-active-class="active">
        <b-avatar size="6rem" v-if="!profileImage"></b-avatar>
        <b-avatar :src="profileImage" size="6rem" v-if="profileImage"></b-avatar>
      </b-nav-item>
      <b-nav-item style="margin: auto;" exact-active-class="active" :to="{ name: 'EditProfile' }">
        <em>{{currentUser.name}}</em>
      </b-nav-item>
      <b-nav-text>
        <hr/>
      </b-nav-text>
      <b-nav-item :to="{ name: 'Home' }" exact-active-class="active">
        HOME
      </b-nav-item>
      <b-nav-item :to="{ name: 'PastCourses' }" exact-active-class="active">
        COURSES
      </b-nav-item>
      <b-nav-text>
        <hr/>
      </b-nav-text>
      <b-nav-item href="https://www.solidprofessor.com/" target="_blank">
        SOLIDPROFESSOR
      </b-nav-item>
      <b-nav-item href="https://hawkridgesys.com/training/course-catalog" target="_blank">
        COURSE CATALOG
      </b-nav-item>
      <b-nav-item href="https://support.hawkridgesys.com/hc/en-us" target="_blank">
        SUPPORT/KB
      </b-nav-item>
      <b-nav-item href="https://hawkridgesys.com/training-faqs" target="_blank">
        FAQS
      </b-nav-item>
      <b-nav-item href="https://www.youtube.com/channel/UC_IJ2fkcLpuyLY3oB-p7Wdg" target="_blank">
        YOUTUBE
      </b-nav-item>
      <b-nav-item href="https://hawkridgesys.com/blog" target="_blank">
        BLOG
      </b-nav-item>
      <b-nav-text>
        <hr/>
      </b-nav-text>
      <b-nav-item :to="{ name: 'Help' }" exact-active-class="active">
        HELP
      </b-nav-item>
      <b-nav-item @click="logout">LOGOUT</b-nav-item>
    </b-nav>
  </div>
</template>

<script>
export default {
  name: 'AppSidebar',
  data () {
    return { }
  },
  computed: {
    currentUser () {
      return this.$store.state.auth.currentUser
    },
    profileImage () {
      return this.$store.state.profileImage.image
    }
  },
  created () {
    this.$store.dispatch('profileImage/load')
      .catch((e) => {
        console.log(e)
      })
  },
  methods: {
    logout () {
      this.$store.dispatch('auth/logout').then(() => {
        this.$router.push({ name: 'Login' })
      })
    }
  }
}
</script>

<style scoped>
.sidebar {
  height: 100%;
  width: 210px;
  max-width: 1024px;
  position: fixed;
  z-index: 1;
  top: 0;
  left: 0;
  overflow-x: hidden;
  box-sizing: border-box;
  margin-top: 55px;
}
.sidebar .nav-link {
  text-align: left;
}
hr {
  margin: 1rem;
  border: 0;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.active {
  font-weight: bold;
}
</style>
